import { attachDiceBoxToCanvas, createNewDiceBox } from "./diceBoxSimulation";
import {
  initDiceBox,
  resetDiceBoxDisplay,
  rollDice
} from "./diceBoxSimulationAggregates";

// Abstracting internal state from consumers
let diceBox = createNewDiceBox();
export { diceBox as _diceBox };

export const diceBoxController = {
  initDiceBox: (scene, world) => {
    diceBox = initDiceBox(diceBox, scene, world);
  },
  attachDiceBoxToCanvas: ({ window, canvas }) => {
    diceBox = attachDiceBoxToCanvas(diceBox, { window, canvas });
  },
  resetDiceBoxDisplay: props => {
    diceBox = resetDiceBoxDisplay(diceBox, props);
  },
  rollDice: props => {
    diceBox = rollDice(diceBox, props);
    return diceBox.animationPromise;
  }
};
